import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
// import { AdminCheckComponent } from "../../components/borrowSystem/AdminCheckComponent";
import { AdminApproveBorrowFormComponent } from "../../components/borrowSystem/AdminApproveBorrowFormComponent";
import { Footer } from "../../components/share/Footer";

export function AdminApproveBorrowFormContainer() {
  const titleName = "รายละเอียดคำขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <AdminApproveBorrowFormComponent />
      <Footer />
    </div>
  );
}
